import { useSkuSelector } from '../hooks/useSkuSelector';

const SelectorItemImageValue = ({ value }: any) => {
	const { blockClass, handles, prodSum } = useSkuSelector();
	const src = `/images/${value}.png`;

	const renderClass = () => blockClass && `vtex-store-components-3-x-skuSelectorItemImageValue--${blockClass}`;

	return (
		<img
			className={`${prodSum ? handles.skuSelectorItemImageValue : ''} skuSelectorItemImageValue skuSelectorItemImageValue--${blockClass} vtex-store-components-3-x-skuSelectorItemImageValue ${renderClass()}`}
			src={src}
			alt="Product Name"
		/>
	);
};

export default SelectorItemImageValue;
